<template>
<keep-alive>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size sm_size">
                <a href="JavaScript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                <dl class="modal_content no_line">
                    <dt class="ellipsis">
                        <slot name="header">{{title}}</slot>
                    </dt>
                    <dd>
                        <dl class="acc_quickdown" v-for="(knwldg, index) in knowledgeInfos" :key="knwldg.KNOWLEDGE_ID">
                            <dt :class="{active: index == 0}" @click="clickFileArea($event, knwldg)">
                                <em v-if="knwldg.ICON" :class="getIconClass(knwldg.ICON)">{{knwldg.ICON}}</em>
                                <em v-if="knwldg.IMPORTANCE_YN == 'Y'" class="textcolor_important">[{{$t('FIELD.GLOBAL.IMPORTANT')}}]</em>
                                <em v-else-if="knwldg.MUST_READ_YN == 'Y'" class="textcolor_must">[{{$t('FIELD.GLOBAL.MUSTREAD')}}]</em>
                                {{knwldg.KNOWLEDGE_TITLE}}
                                <span class="item-date">{{knwldg.REG_USER}} ({{knwldg.REG_DT}})</span>
                            </dt>
                            <dd v-if="knwldg.SHOW">
                                <div v-if="knwldg.attaches && knwldg.attaches.length > 0">
                                    <innorix-download :uploadId="'inno_' + knwldg.KNOWLEDGE_ID" :serviceType="serviceType" :attachList="knwldg.attaches" :seq="knwldg.KNOWLEDGE_ID" />
                                </div>
                                <div v-if="!knwldg.attaches || knwldg.attaches.length == 0">
                                    <span><em>No attach files</em></span>
                                </div>
                                <!-- 200629수정 S -->
                                <dl class="attachment_link" v-if="knwldg.attaches.length > 0">
                                    <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">Having trouble downloading?</a></dt>
                                    <dd>
                                        <ul>
                                            <li v-for="file in knwldg.attaches" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                                <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                                    <span class="ico_attach"></span> {{ file.FILE_NM }}
                                                </a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                                <!-- //Attachment -->
                                <div class="toastr_in_wrap">
                                    <p>{{$t('MESSAGE.POPUP.RECOMMEND')}}</p>
                                    <div class="btn_wrap">
                                        <a href="JavaScript:" @click="toastrRecommend(knwldg.KNOWLEDGE_ID)" class="rdbtn_md_yes">{{$t('FIELD.GLOBAL.YES')}}</a>
                                        <a href="JavaScript:" @click="showBugReportPopup(knwldg.KNOWLEDGE_ID)" class="rdbtn_md_no">{{$t('FIELD.GLOBAL.NO')}}</a>
                                    </div>
                                </div>
                            </dd>
                        </dl>
                    </dd>
                </dl>
            </div>
        </div>
    </div>

</keep-alive>
</template>
<script>
import Vue                      from 'vue';
import qs                       from 'query-string';
import axios                    from 'axios';
import { SDLUtil, MenuUtil }    from '@/utils';
import InnorixDownload          from '~c/InnorixDownload';
import BugReportPopup           from '~c/popup/BugReportPopup';

export default {
    name: 'AttachFilePopup',
    props: [ 'title', 'knowledgeInfos' ],
    data() {
        return {
            serviceType: 'common'
        }
    },
    computed: {
    },
    components: {
        'innorix-download'  : InnorixDownload
    },
    methods: {
        getIconClass(icon) {
            let iconClass = '';
            if (icon == 'R') 
                iconClass = 'textbgbox_recommend';
            else if (icon == 'H')
                iconClass = 'textbgbox_hot';
            else if (icon == 'N')
                iconClass = 'textbgbox_new';
            else if (icon == 'U')
                iconClass = 'textbgbox_update';
            else iconClass = '';

            return iconClass;
        },
        clickFileArea(event, know) {
            $(event.target).parent('dl').parent('dl').children('dl').children('dt').removeClass('active');
            $(event.target).addClass('active');

            this.knowledgeInfos.forEach(elem => { elem.SHOW = false; });
            know.SHOW = true;
        },
        toastrRecommend(knowId) {
            SDLUtil.showLoadingBar(true);
            let url = `${SDLUtil.API_URL}/basis/common/scrap/recommend.skp`,
                param = { workCd: MenuUtil.getScrapWorkCode(), workCdSeq: knowId };
            // Vue.$log.info('▶ RecommendPopup.vue form Data => ', fvParams);
            return  axios.post( url, qs.stringify(param), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } )
                .then(res => {
                    SDLUtil.showLoadingBar(false);
                    Vue.toasted.show( SDLUtil.getMsgProp('MESSAGE.GLOBAL.RECOMMEND'), { theme: "toasted-primary", position: "top-center", duration : 3000 } );
                    this.$emit('close');
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });
        },
        showBugReportPopup(knowId) {
            this.$emit('close');
            SDLUtil.show(
                BugReportPopup, {
                    knowledgeId: this.knowId,
                    rtnFunc: () => {
                        Vue.toasted.show(
                            SDLUtil.getMsgProp('MESSAGE.BUGREPORT.SEND.SUCCESS'),
                            {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                    }
                },
                { height: 'auto' }
            );
        },
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return window.open(cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN);
        },
        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        }
    },
    created() {
    },
    mounted() {
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/intgSearch/AttachFilePopup.vue